import { render, staticRenderFns } from "./GestioneAttivitaClientiEditPage.vue?vue&type=template&id=a8dd897e"
import script from "./GestioneAttivitaClientiEditPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaClientiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports